import { useState } from "react";
import { MessageSquarePlus } from "lucide-react";
import { useAuth } from "@/components/auth/AuthProvider";
import FeedbackSubmitPanel from "./FeedbackSubmitPanel";

export default function FloatingFeedbackButton() {
  const { session } = useAuth();
  const [open, setOpen] = useState(false);

  if (!session) return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-20 right-4 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg transition-transform hover:scale-110 glow-primary"
        aria-label="Submit feedback"
      >
        <MessageSquarePlus className="h-5 w-5" />
      </button>
      <FeedbackSubmitPanel open={open} onOpenChange={setOpen} />
    </>
  );
}
